import { render, staticRenderFns } from "./devList.vue?vue&type=template&id=2e6a1ba2"
import script from "./devList.vue?vue&type=script&lang=js"
export * from "./devList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports